import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";
import "../../Styles/HeatmapConfiguration.scss";
import { ColorGradient, Switch } from "@progress/kendo-react-inputs";
import { Window } from "@progress/kendo-react-dialogs";
import Api from "../../Services/Api";
import { toastr } from "react-redux-toastr";
import { CircularProgress } from "@material-ui/core";
import HeatMapConfigData from "./HeatMapConfigData.json";
class HeatmapConfiguration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      currentColor: "",
      openColorWindow: false,
      heatMapCount: 0,
      HeatMapConfigDataOpportunity: [],
      HeatMapConfigDataThreat: [],
      dynamicHeatmapProbabilityRange: [],
    };
  }

  componentDidMount = () => {
    this.isAuthorizeUse();
  };

  isAuthorizeUse = async () => {
    if (!secureLocalStorage.getItem("authToken")) {
      if (this.props.match.params.id) {
        this.props.history.push({
          pathname: `/tenant/${this.props.match.params.id}`,
        });
      } else {
        this.props.history.push({
          pathname: "/",
        });
      }
    } else {
      this.getmatrix();
    }
  };

  getmatrix = async () => {
    try {
      this.setState({ ...this.state, loader: true });
      let response = await Api.MatrixColor();
      if (response.status === 200 && response.matrixColor) {
        // normal,opportunity
        let normal_opp = response.matrixColor.find(
          (item) => item.riskType === "opportunity"
        );
        let opp_colorJsonData = JSON.parse(normal_opp.colorJsonData);

        //  normal,threat
        let normal_threat = response.matrixColor.find(
          (item) => item.riskType === "threat"
        );
        let threat_colorJsonData = JSON.parse(normal_threat.colorJsonData);

        this.setState({
          loader: false,
          HeatMapConfigDataThreat: threat_colorJsonData,
          HeatMapConfigDataOpportunity: opp_colorJsonData,

          // HeatMapConfigDataThreat: JSON.parse(
          //   JSON.stringify(HeatMapConfigData.threat)
          // ),
          // HeatMapConfigDataOpportunity: JSON.parse(
          //   JSON.stringify(HeatMapConfigData.opportunity)
          // ),
          heatMapCount: response.heatmapCount,
          dynamicHeatmapProbabilityRange:
            response.dynamicHeatmapProbabilityRange,
        });
      } else {
        this.setState({
          loader: false,
        });
      }
    } catch (err) {
      console.error(err);
      this.setState({
        loader: false,
      });
    }
  };

  handleSubmit = async () => {
    if (this.state.checked === false) {
      let request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
        RiskType: "Threat",
        ColorJsonData: JSON.stringify(this.state.HeatMapConfigDataThreat),
      };
      let response = await Api.SaveMatrixColor(request);
      if (response.status === 200) {
        this.setState({ loader: false });
        toastr.success(response.message);
      } else {
        this.setState({ loader: false });
        toastr.error(response.message);
      }
    } else {
      let request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
        RiskType: "Opportunity",
        ColorJsonData: JSON.stringify(this.state.HeatMapConfigDataOpportunity),
      };
      let response = await Api.SaveMatrixColor(request);
      if (response.status === 200) {
        this.setState({ loader: false });
        toastr.success(response.message);
      } else {
        this.setState({ loader: false });
        toastr.error(response.message);
      }
    }
  };

  handlereset = () => {
    if (!this.state.checked) {
      this.setState({
        HeatMapConfigDataThreat: JSON.parse(
          JSON.stringify(HeatMapConfigData.threat)
        ),
        openColorWindow: false,
        currentColor: "",
      });
    } else {
      this.setState({
        HeatMapConfigDataOpportunity: JSON.parse(
          JSON.stringify(HeatMapConfigData.opportunity)
        ),
        openColorWindow: false,
        currentColor: "",
      });
    }
  };
  handleCancel = () => {
    this.setState({
      ...this.state,
      openColorWindow: false,
      currentColor: "",
    });
  };

  closeToggleClose = () => {
    this.setState({ openColorWindow: false, currentColor: "" });
  };

  handleColor = (index1, index2, defaultColorCode) => {
    console.log(index1, index2, defaultColorCode);
    this.setState({
      openColorWindow: true,
      currentColor: defaultColorCode,
      index1: index1,
      index2: index2,
    });
  };

  handleColorPicker = (e) => {
    try {
      var {
        HeatMapConfigDataOpportunity,
        HeatMapConfigDataThreat,
        checked,
        index1,
        index2,
      } = this.state;
      if (checked) {
        let arr2 = HeatMapConfigDataOpportunity?.map((item, ind1) => {
          item["row"] = item?.row?.map((cols, ind2) => {
            if (ind1 === index1 && ind2 === index2) {
              cols["colorCode"] = e.value;
            }
            return cols;
          });
          return item;
        });
        this.setState({
          HeatMapConfigDataOpportunity: arr2,
          currentColor: e.value,
        });
      } else {
        let arr1 = HeatMapConfigDataThreat?.map((item, ind1) => {
          item["row"] = item?.row?.map((cols, ind2) => {
            if (ind1 === index1 && ind2 === index2) {
              cols["colorCode"] = e.value;
            }
            return cols;
          });
          return item;
        });
        this.setState({
          HeatMapConfigDataThreat: arr1,
          currentColor: e.value,
        });
      }
    } catch (err) {
      console.error(err);
    }
  };
  xaxis_alignment = () => {
    if (this.state.heatMapCount === 3 || this.state.heatMapCount === 4) {
      return <h5 style={{ marginTop: "80px" }}>Probability (%)</h5>;
    } else if (this.state.heatMapCount === 5) {
      return <h5 style={{ marginTop: "118px" }}>Probability (%)</h5>;
    } else if (this.state.heatMapCount === 6) {
      return <h5 style={{ marginTop: "130px" }}>Probability (%)</h5>;
    } else if (this.state.heatMapCount === 7 || this.state.heatMapCount === 8) {
      return <h5 style={{ marginTop: "160px" }}>Probability (%)</h5>;
    }
  };

  yaxis_alignment = () => {
    if (this.state.heatMapCount === 3) {
      return (
        <div className="x-axis" style={{ marginLeft: "200px" }}>
          Impact
        </div>
      );
    } else if (this.state.heatMapCount === 4) {
      return (
        <div className="x-axis" style={{ marginLeft: "240px" }}>
          Impact
        </div>
      );
    } else if (this.state.heatMapCount === 5) {
      return (
        <div className="x-axis" style={{ marginLeft: "270px" }}>
          Impact
        </div>
      );
    } else if (this.state.heatMapCount === 6) {
      return (
        <div className="x-axis" style={{ marginLeft: "298px" }}>
          Impact
        </div>
      );
    } else if (this.state.heatMapCount === 7 || this.state.heatMapCount === 8) {
      return (
        <div className="x-axis" style={{ marginLeft: "338px" }}>
          Impact
        </div>
      );
    }
  };
  render() {
    const {
      heatMapCount,
      HeatMapConfigDataThreat,
      HeatMapConfigDataOpportunity,
      dynamicHeatmapProbabilityRange,
    } = this.state;
    const probabilityRange = [...dynamicHeatmapProbabilityRange]?.reverse();
    return (
      <div className="matrix_color">
        {this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}
        <h3 className="heatmap_header">Heatmap Colour Configuration</h3>

        <div className="btn_hm">
          <div className="switchHist">
            <Switch
              onChange={(event) => {
                this.setState({ checked: event.target.value });
              }}
              checked={this.state.checked}
              onLabel={"Opportunity"}
              offLabel={"Threat"}
              defaultChecked={false}
              className="medium"
              size="150px"
            />
          </div>
        </div>

        <div className="heatmap_chart">
          <div className="hmOuterGrid ">
            <div className="outerGridRow">
              <div className="x-axis">{this.xaxis_alignment()}</div>
              <div className="outerGridBox lLegendSubtitle">
                <div className="lLegend">
                  {probabilityRange?.map((prob, i) => {
                    return (
                      <label style={{ fontSize: "12px" }}>
                        {prob.probabilityRangeValue}-
                        {i === 0
                          ? 100
                          : probabilityRange[i - 1]?.probabilityRangeValue - 1}
                      </label>
                    );
                  })}
                </div>
              </div>
              <div className="outerGridBox bLegendContainer">
                {this.state.checked ? (
                  <div className="innerGridCont">
                    {HeatMapConfigDataOpportunity?.slice(0, heatMapCount)?.map(
                      (item, index1) => {
                        return (
                          <div className="innerGridRow">
                            {item?.row
                              ?.slice(0, heatMapCount)
                              ?.map((cols, index2) => {
                                return (
                                  <div className="innerGridRow" key={index2}>
                                    <div
                                      className="innerGridBox"
                                      id="r5"
                                      style={{
                                        backgroundColor: cols.colorCode,
                                      }}
                                      onClick={() =>
                                        this.handleColor(
                                          index1,
                                          index2,
                                          cols.colorCode
                                        )
                                      }
                                    >
                                      <p style={{ width: "100px" }}></p>
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                        );
                      }
                    )}
                    <div className=" y_axis">
                      {probabilityRange.map((item) => {
                        return (
                          <div className=" y_axis_colorblock">
                            <label>{item.abbreviation?.toUpperCase()}</label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  <div className="innerGridCont">
                    {HeatMapConfigDataThreat?.slice(0, heatMapCount)?.map(
                      (item, index1) => {
                        return (
                          <div className="innerGridRow">
                            {item?.row
                              ?.slice(0, heatMapCount)
                              ?.map((cols, index2) => {
                                return (
                                  <div className="innerGridRow" key={index2}>
                                    <div
                                      className="innerGridBox"
                                      id="r5"
                                      style={{
                                        backgroundColor: cols.colorCode,
                                      }}
                                      onClick={() =>
                                        this.handleColor(
                                          index1,
                                          index2,
                                          cols.colorCode
                                        )
                                      }
                                    >
                                      <p style={{ width: "100px" }}></p>
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                        );
                      }
                    )}
                    <div className=" y_axis">
                      {dynamicHeatmapProbabilityRange.map((item) => {
                        return (
                          <div className=" y_axis_colorblock">
                            <label>{item.abbreviation?.toUpperCase()}</label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
                {/* outerGridBox bLegendContainer */}{" "}
              </div>
              {/* outerGridRow */}
            </div>
            <div className="outerGridRow">
              <div className="outerGridBox lLegendTitle"></div>
              <div className="outerGridBox lLegendSubtitle"></div>
              <div
                className="outerGridBox bLegendContainer"
                style={{ paddingTop: "30px" }}
              >
                {this.yaxis_alignment()}
              </div>
            </div>

            {this.state.openColorWindow && (
              <Window
                title="Custom Colour Palette"
                onClose={this.closeToggleClose}
                initialLeft={750}
                initialTop={210}
                initialWidth={380}
                initialHeight={300}
                // draggable={false}
              >
                <div className="color_picker">
                  <ColorGradient
                    onChange={this.handleColorPicker}
                    value={this.state.currentColor}
                  />
                </div>
              </Window>
            )}
          </div>

          <div className="matrix_submit">
            <button
              className="hm-cancel-btn"
              onClick={this.handleCancel}
              type="button"
            >
              Cancel
            </button>
            <button
              className="hm-submit-btn"
              onClick={this.handleSubmit}
              type="button"
            >
              Submit
            </button>
            <button
              className="hm-reset-btn"
              onClick={this.handlereset}
              type="button"
            >
              Reset
            </button>
          </div>
        </div>
      </div>
    );
  }
}
export default HeatmapConfiguration;
